var _defs, _g, _path, _g2, _path2, _path3, _rect, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaggenerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo-CostCalculator",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #064b93;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #6ebc81;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-CostCalculator1",
    "data-name": "Logo-CostCalculator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st0",
    d: "M0,62.3h104v32c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10v-32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st2",
    d: "M104,62.3H0V10.3C0,4.8,4.5.3,10,.3h84c5.5,0,10,4.5,10,10v52h0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.9,36l-15.8,15c-.4.4-.9.7-1.5.9s-1.1.3-1.7.3-1.1-.1-1.7-.3-1.1-.5-1.5-.9l-19.6-18.5c-.4-.4-.7-.8-.9-1.3s-.3-1-.3-1.6v-15.1c0-1.2.4-2.1,1.3-3s1.9-1.2,3.1-1.2h15.9c.6,0,1.2.1,1.7.3s1,.5,1.4.9l19.5,18.5c.4.4.8.9,1,1.4s.3,1.1.3,1.6-.1,1-.3,1.5-.5,1-1,1.4ZM53.9,48.1l15.8-15-19.6-18.6h-15.8v15l19.6,18.6ZM39.8,22.9c.9,0,1.7-.3,2.4-.9s1-1.4,1-2.2-.3-1.6-1-2.2-1.4-.9-2.4-.9-1.7.3-2.4.9-1,1.4-1,2.2.3,1.6,1,2.2,1.4.9,2.4.9Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,82.1h4.1v9.2c-2.4,1.9-5.8,2.9-9,2.9-7.2,0-12.4-5-12.4-11.9s5.3-11.9,12.5-11.9,7.1,1.3,9.3,3.8l-2.7,2.6c-1.8-1.8-3.9-2.6-6.4-2.6-4.9,0-8.4,3.3-8.4,8.1s3.5,8.1,8.4,8.1,3.3-.3,4.8-1.2v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.1,90.3v3.6h-17.3v-23.1h16.9v3.6h-12.6v6h11.2v3.5h-11.2v6.4h13Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,64.6l-4.6,4.8c-.2.2-.6.2-.8,0L0,33.4v-9.9l43.4,41.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,72.1l-4.6,4.8c-.2.2-.6.2-.8,0L0,52.8v-9.9l30.9,29.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 34.1,
    y: 62.3,
    width: 23.8,
    height: 6.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14261",
    "data-name": "Rectangle_1426"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94,2.3c4.4,0,8,3.6,8,8v50H2V10.3C2,5.9,5.6,2.3,10,2.3h84M94,.3H10C4.5.3,0,4.8,0,10.3v52h104V10.3c0-5.5-4.5-10-10-10h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggenerator);
export default __webpack_public_path__ + "static/media/taggenerator.9774024dfc0f110a34ebbc7e739fcc0e.svg";
export { ForwardRef as ReactComponent };